import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Spinner from './Spinner';

export default class NavBar extends React.Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    isCustomerPortal: PropTypes.bool.isRequired,
    isCustomerAdmin: PropTypes.bool.isRequired,
    logoutFunction: PropTypes.func.isRequired,
    progress: PropTypes.number.isRequired,
    user: PropTypes.object,
  };

  static defaultProps = {
    user: null,
  };

  state = {
    showUserMenu: false,
    timeoutReference: null,
  };

  getUserMenuClass = showUserMenu => {
    if (showUserMenu) {
      return 'nav-item dropdown pull-xs-right open';
    }
    return 'nav-item dropdown pull-xs-right';
  };

  closeUserMenu = () => {
    this.setState({ showUserMenu: false });
  };

  handleUserMenuClick = evt => {
    const updatedShowUserMenu = !this.state.showUserMenu;
    evt && evt.preventDefault();
    this.setState({ showUserMenu: updatedShowUserMenu });
  };

  logoutClick = () => {
    const { logoutFunction } = this.props;
    this.closeUserMenu();
    logoutFunction();
  };

  navMouseLeave = () => {
    if (this.state.showUserMenu) {
      this.clearTimeoutReference();
      this.setState({ timeoutReference: setTimeout(this.closeUserMenu, 500) });
    }
  };

  navMouseEnter = () => {
    if (this.state.showUserMenu) {
      this.clearTimeoutReference();
    }
  };

  clearTimeoutReference = () => {
    const { timeoutReference } = this.state;
    if (timeoutReference !== null) {
      clearTimeout(timeoutReference);
    }
  };

  renderUserMenu = () => {
    const { user, progress, isCustomerAdmin, isCustomerPortal } = this.props;
    const { showUserMenu } = this.state;

    return (
      <ul className="nav navbar-nav">
        <li
          className={this.getUserMenuClass(showUserMenu)}
          onMouseLeave={this.navMouseLeave}
          onMouseEnter={this.navMouseEnter}
        >
          <button
            className="nav-link dropdown-toggle link-button"
            aria-haspopup="true"
            aria-expanded="false"
            onClick={this.handleUserMenuClick}
          >
            {user && user.firstName ? user.firstName : 'Welcome'}
          </button>
          <div className="dropdown-menu">
            {isCustomerAdmin ? (
              <Link
                className="dropdown-item account-link"
                to="/admin/home"
                onClick={this.closeUserMenu}
              >
                Admin
              </Link>
            ) : null}
            {isCustomerPortal ? (
              <Link
                className="dropdown-item account-link"
                to="/user-settings"
                onClick={this.closeUserMenu}
              >
                My Account
              </Link>
            ) : null}
            {!isCustomerPortal ? (
              <Link
                className="dropdown-item account-link"
                to={`/users/${user.accountId}/edit/${user.id}`}
                onClick={this.closeUserMenu}
              >
                Edit Account
              </Link>
            ) : null}
            <Link className="dropdown-item account-link" to="/privacy" onClick={this.closeUserMenu}>
              Privacy Policy
            </Link>
            <button
              className="dropdown-item log-out-link button-link"
              href="#"
              onClick={this.logoutClick}
            >
              Log Out
            </button>
          </div>
        </li>
        {/* <li className="nav-item pull-xs-right notifications">
          <span className="fa fa-bell-o"></span>
        </li> */}
        <li className="nav-item pull-xs-right">
          <Spinner show={progress} />
        </li>
      </ul>
    );
  };

  renderAdminMenu = () => (
    <div>
      <div className="dropdown-divider" />
      <Link
        className="dropdown-item admin-menu"
        to="/superadmin/accounts"
        onClick={this.closeUserMenu}
      >
        Company Accounts
      </Link>
      <Link
        className="dropdown-item admin-menu"
        to="/superadmin/listsummary"
        onClick={this.closeUserMenu}
      >
        View Customer Datasets
      </Link>
      <Link
        className="dropdown-item admin-menu"
        to="/superadmin/token"
        onClick={this.closeUserMenu}
      >
        Token
      </Link>
    </div>
  );

  renderLoginLink = () => {
    const { progress } = this.props;
    return (
      <ul className="nav navbar-nav">
        <li className="nav-item pull-xs-right">
          <Link className="nav-link admin-menu" to="/account/login">
            Log In
          </Link>
        </li>
        <li className="nav-item pull-xs-right">
          <Spinner show={progress} />
        </li>
      </ul>
    );
  };

  render() {
    const { isAuthenticated, isCustomerPortal } = this.props;
    let title = 'Portal';
    if (isAuthenticated) {
      if (isCustomerPortal) title = 'Customer Portal';
      else title = 'Partner Portal';
    }

    return (
      <nav className="navbar navbar-light bg-faded navbar-fixed-top">
        <Link className="navbar-brand" to="/">
          <span className="logo">Datarista</span>
          {title}
        </Link>
        {isAuthenticated ? this.renderUserMenu() : this.renderLoginLink()}
      </nav>
    );
  }
}
